class ProductStitcher extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.productStitchers = this.querySelectorAll('[js-product-sticher]');

        this.productStitchers.forEach(stitcher => {
        if (!stitcher.classList.contains('stitcher-initialized')) {
            stitcher.classList.add('stitcher-initialized');

            stitcher.addEventListener('click', async () => {
            const productHandle = stitcher.dataset.productHandle;
            this.productStitchers.forEach(item => item.classList.remove('stitch-slider__active'));
            stitcher.classList.add('stitch-slider__active');

            await this.renderProduct(productHandle, stitcher);
            });
        }
        });
    }
    async renderProduct(productHandle, target) {
        try {
        const response = await fetch(`${location.origin}${Shopify.routes.root}products/${productHandle}?view=cs-product-card`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const productGridAjax = parsed.querySelector('.product-card-wrapper');
        
        if (productGridAjax) {
            const productGrid = target.closest('.product-card-wrapper');
            if (productGrid) {
            productGrid.innerHTML = productGridAjax.innerHTML;
            }
        }
        document.dispatchEvent(new CustomEvent('stitcher-slider:init'));
        } catch (error) {
        console.error('Error fetching product details:', error);
        }
    }
}

customElements.define('product-stitcher', ProductStitcher);